<template>
  <div class="navigation auto">
    <v-list class="auto-nav-list">
      <v-list-item
        :to="`/autos/${$route.params.autoId}/info`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.info') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_state')"
        :to="`/autos/${$route.params.autoId}/current-state`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.currentState') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_rent_history')"
        :to="`/autos/${$route.params.autoId}/rents`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.rentsHistory') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_change_history')"
        :to="`/autos/${$route.params.autoId}/history`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.history') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_rent_rate_history')"
        :to="`/autos/${$route.params.autoId}/rates`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('rates.history') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_fine')"
        :to="`/autos/${$route.params.autoId}/fines`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('fines.title') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_accident')"
        :to="`/autos/${$route.params.autoId}/dtp`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('dtp.title') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="checkAccess('investor_car_internal_maintenance_show')"
        :to="`/autos/${$route.params.autoId}/internal-maintenance`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">
            {{ $t('auto.internalMaintenance') }}
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'DriverNavigation',
  methods: {
    checkAccess(permission) {
      const isInvestor = this.$store.getters['global/getRole'] === 'investor';
      return !isInvestor || this.$can(permission);
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  &.auto {
    width: 100%;
    background: transparent;

    .auto-nav-list {
      display: flex;
      background: transparent;
      font-size: 14px;

      @media (max-width: (650px)) {
        display: block;
      }
    }
  }

  .v-list-item {
    padding: 10px;
  }
}
</style>
